import { useCallback, useEffect, useRef, useState } from 'react';
import { CreditCard, RefreshCw } from 'lucide-react';
import { Button } from '../ui/button';
import { proshopApi, proshopError } from './proshopApi';

export const CoursePayoutStatus = ({ businessId, adminKey, permissionVersion }) => {
  const [status, setStatus] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  const [busy, setBusy] = useState(false);
  const generation = useRef(0);
  const load = useCallback(async () => {
    const current = ++generation.current;
    setLoading(true); setError(''); setStatus(null);
    try { const value = await proshopApi.stripeStatus(businessId, adminKey); if (current === generation.current) setStatus(value); }
    catch (e) { if (current === generation.current) setError(proshopError(e)); }
    finally { if (current === generation.current) setLoading(false); }
  }, [businessId, adminKey]);
  useEffect(() => { load(); return () => { generation.current++; }; }, [load, permissionVersion]);
  const start = async () => {
    if (busy) return;
    setBusy(true); setError('');
    try { const data = await proshopApi.stripeLink(); window.location.assign(data.onboarding_url); }
    catch (e) { setError(proshopError(e)); setBusy(false); }
  };
  const labels = { not_connected: 'Not connected', incomplete: 'Setup incomplete', pending_verification: 'Stripe verification pending', active: 'Stripe account ready' };
  return <section className="course-section" data-testid="course-payout-status">
    <div className="course-toolbar"><CreditCard className="text-green-600" size={22} aria-hidden="true" /><h2>Course payouts</h2></div>
    <p className="course-subtle mt-3">Bank details are entered securely with Stripe. Par Seeker never collects full card or bank numbers.</p>
    {loading ? <p className="mt-4" role="status" data-testid="course-payout-loading">Checking Stripe status…</p> : status && <>
      <p className="course-badge mt-4" data-testid="course-stripe-status-label">{labels[status.status] || status.status}</p>
      {status.bank_last4 && <p className="mt-3" data-testid="course-bank-masked">{status.bank_name || 'Bank account'} · •••• {status.bank_last4}</p>}
      <dl className="course-summary" data-testid="course-stripe-capabilities"><dt>Charges enabled</dt><dd>{status.charges_enabled ? 'Yes' : 'Not yet'}</dd><dt>Payouts enabled</dt><dd>{status.payouts_enabled ? 'Yes' : 'Not yet'}</dd></dl>
    </>}
    {error && <p role="alert" className="course-error" data-testid="course-payout-error">{error}</p>}
    <div className="course-toolbar mt-5">
      {!businessId && <Button className="course-primary" disabled={busy || loading} onClick={start} data-testid="course-stripe-setup">{busy ? 'Opening Stripe…' : status?.status === 'active' ? 'Review Stripe details' : 'Continue with Stripe'}</Button>}
      <Button variant="outline" disabled={busy || loading} onClick={load} data-testid="course-stripe-refresh"><RefreshCw size={16} className="mr-2" />Refresh status</Button>
    </div>
  </section>;
};